import React, { Component } from "react";
import LandingPageLogo from "../assets/LandingPageLogo.svg";
import ScrollDownRed from "../assets/ScrollDownRed.svg";
import ScrollDownYellow from "../assets/ScrollDownYellow.svg";
import BlackCircleTransition from "../assets/BlackCircleTransition.svg";
import BlueTriangleTransition from "../assets/BlueTriangleTransition.svg";
import PricingImg from "../assets/PricingImg.svg";
// import Lottie from "react-lottie";
// import loadingAnimation from "../assets/loading.json";

import { Link } from "react-router-dom";
import { Element, scroller } from "react-scroll";
import ScrollAnimation from "react-animate-on-scroll";

import {
  FaFingerprint,
  FaUnlockAlt,
  FaMobileAlt,
  FaSearch,
} from "react-icons/fa";

const ratio = 2.185;

export default class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      width: 0,
      height: 0,
      // loading: true,
      fadeOut: false,
      fadeIn: false,
    };
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    // window.addEventListener("load", this.loadingDone);
    this.setState({ fadeIn: true });
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
    // window.removeEventListener("load", this.loadingDone);
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  };

  loadingDone = () => {
    console.log("Done Loading");

    this.setState(
      {
        fadeOut: true,
      },
      () => {
        setTimeout(() => {
          console.log("fadeIn True");
          this.setState({ loading: false, fadeIn: true });
        }, 500);
      }
    );
  };

  scrollToPage2 = () => {
    scroller.scrollTo("page2", {
      duration: 600,
      delay: 100,
      smooth: true,
    });
  };

  scrollToPage3 = () => {
    scroller.scrollTo("page3", {
      duration: 600,
      delay: 100,
      smooth: true,
    });
  };

  render() {
    // return this.state.loading ? (
    //   <div className={this.state.fadeOut ? "loading fadeOut" : "loading"}>
    //     <Lottie
    //       options={{
    //         loop: true,
    //         autoplay: true,
    //         animationData: loadingAnimation,
    //       }}
    //       height={400}
    //       width={400}
    //       isStopped={false}
    //       isPaused={false}
    //     />
    //   </div>
    // ) : (
    return (
      <div className={this.state.fadeIn ? "home fadeIn" : "home"}>
        <Element name="page1">
          <div className="page-1">
            <div className="wrapper page-1-container">
              <div className="page-1-logo-container">
                <ScrollAnimation animateIn="fadeInDown">
                  <img src={LandingPageLogo} alt="" className="svg-home" />
                </ScrollAnimation>
              </div>
              <p className="title white">
                Freelance Web{" "}
                <span className="highlighted">
                  {this.state.width < 1420 ? <br></br> : null}Developer
                </span>{" "}
                & <span className="highlighted">Designer</span>
              </p>
              <p className="title-sub-text sub-text">
                Fully customized websites tailored to your needs.
              </p>
            </div>
            <div onClick={this.scrollToPage2} className="scroll-down-container">
              <img src={ScrollDownRed} alt="" className="scroll-down" />
            </div>
          </div>
        </Element>

        <Element name="page2">
          <div className="page-2">
            <div className="wrapper page-2-container">
              <p className="title tan">Features</p>
              <div className="page-2-grid">
                <div className="page-2-grid-item">
                  <FaFingerprint className="page-2-icon"></FaFingerprint>
                  <div className="title-small white">customization</div>
                  <div className="sub-text">
                    I offer both static and dynamic websites that allow clients
                    to easily customize personal content on their own.
                  </div>
                </div>
                <div className="page-2-grid-item">
                  <FaUnlockAlt className="page-2-icon"></FaUnlockAlt>
                  <div className="title-small white">security</div>
                  <div className="sub-text">
                    SSL is provided on deployment for client data encryption.
                    This will help ensure the security of your data.
                  </div>
                </div>
                <div className="page-2-grid-item">
                  <FaMobileAlt className="page-2-icon"></FaMobileAlt>
                  <div className="title-small white">responsiveness</div>
                  <div className="sub-text">
                    All clients will receive websites with a desktop and mobile
                    friendly design, expanding your product to mobile users.
                  </div>
                </div>
                <div className="page-2-grid-item">
                  <FaSearch className="page-2-icon"></FaSearch>
                  <div className="title-small white">optimization</div>
                  <div className="sub-text">
                    SEO techniqures are implemented to better rank the final
                    product with popular search engines such as Google.
                  </div>
                </div>
              </div>
            </div>
            <div onClick={this.scrollToPage3} className="scroll-down-container">
              <img src={ScrollDownYellow} alt="" className="scroll-down" />
            </div>
            <img src={BlackCircleTransition} alt="" className="transition" />
          </div>
        </Element>
        <Element name="page3">
          <div className="page-3">
            <div className="wrapper page-3-container">
              {/* {this.state.width <= 1200 ? (
              <div className="page-3-right">
                <img src={PricingImg} alt="" className="svg" />
              </div>
            ) : null} */}

              <div className="page-3-left">
                <div className="title white">
                  Web Applications Starting at $300
                </div>
                <div className="sub-text">
                  Pricing varies depending on the size of the project and the
                  needs of the client. To get started, contact me and let me
                  know that you are interested. We can discuss what exactly you
                  are looking for in your custom website.
                </div>
                {this.state.width > 1200 ? (
                  <Link to="/contact" className="btn btn-blue">
                    get started
                  </Link>
                ) : null}
              </div>
              {/* {this.state.width > 1200 ? (
              <div className="page-3-right">
                <img src={PricingImg} alt="" className="svg" />
              </div>
            ) : null} */}
              <div className="page-3-right">
                <img src={PricingImg} alt="" className="svg" />
              </div>

              {this.state.width <= 1200 ? (
                <Link to="/contact" className="btn btn-blue">
                  get started
                </Link>
              ) : null}
            </div>
            <img
              src={BlueTriangleTransition}
              alt=""
              className="transition transition-2"
            />
          </div>
        </Element>
      </div>
    );
    // );
  }
}
